import * as React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { LoginHostedPage } from './LoginHostedPage';
import { ErrorPage } from './passwordless-login/components/pages/error/ErrorPage';
import { BootstrapRegistrationPage } from './passwordless-login/components/pages/bootstrap/BootstrapRegistrationPage';
import { BootstrapLoginPage } from './passwordless-login/components/pages/bootstrap/BootstrapLoginPage';
import { VersionPage } from './passwordless-login/components/pages/version/VersionPage';
import { BootstrapResetPasswordPage } from './passwordless-login/components/pages/bootstrap/BootstrapResetPasswordPage';
import { ROUTES } from 'ts/Routes';
import { ForgotUsernameCustomerLookupPage } from './passwordless-login/components/wizards/forgot-username-wizard/ForgotUsernameCustomerLookupPage';
import { ManualRegCustomerLookupPage } from './passwordless-login/components/wizards/manual-reg-wizard/ManualRegCustomerLookupPage';
import { ForgotUsernameAccountNumberPage } from './passwordless-login/components/wizards/forgot-username-wizard/ForgotUsernameAccountNumberPage';
import { ManualRegAccountNumberPage } from './passwordless-login/components/wizards/manual-reg-wizard/ManualRegAccountNumberPage';
import { ManualRegOneTimeCodePage } from './passwordless-login/components/wizards/manual-reg-wizard/ManualRegOneTimeCodePage';
import { RegisterEnterUsernamePage } from './passwordless-login/components/wizards/register-wizard/RegisterEnterUsernamePage';
import { ForgotPasswordEnterUsernamePage } from './passwordless-login/components/wizards/forgot-password-wizard/ForgotPasswordEnterUsernamePage';
import { RegisterOneTimeCodePage } from './passwordless-login/components/wizards/register-wizard/RegisterOneTimeCodePage';
import { ForgotPasswordOneTimeCodePage } from './passwordless-login/components/wizards/forgot-password-wizard/ForgotPasswordOneTimeCodePage';
import { RegisterSetPasswordPage } from './passwordless-login/components/wizards/register-wizard/RegisterSetPasswordPage';
import { ForgotUsernameAccountFoundPage } from './passwordless-login/components/wizards/forgot-username-wizard/ForgotUsernameAccountFoundPage';
import { LoginPage } from './login/components/Login/LoginPage';
import { navigateToErrorPageFromLogin } from './passwordless-login/components/pages/error/ErrorNavigation';
import { CallCentreRegisterWizardThankyouPage } from './passwordless-login/components/wizards/call-centre-register-wizard/CallCentreRegisterWizardThankyouPage';
import { CallCentreResetPasswordWizardThankyouPage } from './passwordless-login/components/wizards/call-centre-reset-password-wizard/CallCentreResetPasswordWizardThankyouPage';

interface RouterState {
  username: string;
}

class AppRouter extends React.Component<{}, RouterState> {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
    };
  }

  /**
   * Sets the username across all the routes. Username has been elevated to app level as when
   * returning (hitting back) from the error page, we want the username to be persistant.
   * Also, when we add the register route, and they navigate from login -> register
   * we would like to maintain the username
   * @param username: string
   */
  public setUsername = (username: string) => {
    this.setState({ username });
  };

  // used mostly for native as native cannot use the bootstrap links
  public renderNativeLoginPage = (props) => (
    <LoginPage
      username={this.state.username}
      setUsername={this.setUsername}
      isUserNameCheckEnabled={true}
      errorPageFunction={(errorCode, history) => navigateToErrorPageFromLogin(errorCode, history)}
      {...props}
    />
  );

  public render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path={ROUTES.ROOT} component={LoginHostedPage} />
          <Route exact path={ROUTES.ERROR} component={ErrorPage} />
          <Route path={ROUTES.LOGIN_START} component={BootstrapLoginPage} />
          <Route exact path={ROUTES.LOGIN} render={this.renderNativeLoginPage} />

          <Route path={ROUTES.REGISTER_START} component={BootstrapRegistrationPage} />
          <Route exact path={ROUTES.REGISTER_ENTER_USERNAME} render={RegisterEnterUsernamePage} />
          <Route path={ROUTES.REGISTER_ONE_TIME_CODE} component={RegisterOneTimeCodePage} />

          <Route path={ROUTES.MANUAL_REG_FIND_CUSTOMER} component={ManualRegCustomerLookupPage} />
          <Route path={ROUTES.MANUAL_REG_ACCOUNT_NUMBER} component={ManualRegAccountNumberPage} />
          <Route path={ROUTES.MANUAL_REG_ONE_TIME_CODE} component={ManualRegOneTimeCodePage} />

          <Route path={ROUTES.RESET_PASSWORD_START} component={BootstrapResetPasswordPage} />
          <Route
            exact
            path={ROUTES.RESET_PASSWORD_ENTER_USERNAME}
            render={ForgotPasswordEnterUsernamePage}
          />
          <Route
            path={ROUTES.RESET_PASSWORD_ONE_TIME_CODE}
            component={ForgotPasswordOneTimeCodePage}
          />

          <Route
            path={ROUTES.FORGOT_USERNAME_FIND_CUSTOMER}
            component={ForgotUsernameCustomerLookupPage}
          />
          <Route
            path={ROUTES.FORGOT_USERNAME_ACCOUNT_NUMBER}
            component={ForgotUsernameAccountNumberPage}
          />

          <Route
            path={ROUTES.FORGOT_USERNAME_ACCOUNT_FOUND}
            component={ForgotUsernameAccountFoundPage}
          />

          <Route
            path={ROUTES.CALL_CENTRE_REGISTER_THANKYOU}
            component={CallCentreRegisterWizardThankyouPage}
          />

          <Route
            path={ROUTES.CALL_CENTRE_RESET_PASSWORD_THANKYOU}
            component={CallCentreResetPasswordWizardThankyouPage}
          />

          {/* The set password route is used only for testing purposes, this page is actually served from reset_password.ejs as an auth0 hosted page.  See ResetPasswordRouter.tsx */}
          <Route path={ROUTES.REGISTER_SET_YOUR_PASSWORD} component={RegisterSetPasswordPage} />
          <Route path={ROUTES.VERSION} component={VersionPage} />
        </Switch>
      </HashRouter>
    );
  }
}

export { AppRouter };
